var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { getFelicaBrandDisplayName } from '@square/dashboard-data/utils/felica-brand';
import { getDisplayName } from '@square/dashboard-data/utils/card-brand';
let UnsuccessfulPaymentHelper = (_class = class UnsuccessfulPaymentHelper extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  felicaBrandName(felicaBrand) {
    return getFelicaBrandDisplayName(felicaBrand, this.intl);
  }
  cardBrandName(cardBrand) {
    return getDisplayName(cardBrand, this.intl, this.features);
  }
  statusName(status) {
    if (status) {
      const key = status.toLowerCase();
      // eslint-disable-next-line square/no-translation-key-interpolation
      return this.intl.t(`activity.reports.unsuccessfulPayments.statuses.${key}`);
    }
    return undefined;
  }
  squareProductName(squareProduct) {
    if (squareProduct) {
      const key = squareProduct.toLowerCase();
      try {
        // eslint-disable-next-line square/no-translation-key-interpolation
        return this.intl.t(`activity.reports.unsuccessfulPayments.products.${key}`);
      } catch {
        return this.intl.t('activity.reports.unsuccessfulPayments.products.unknown');
      }
    }
    return undefined;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { UnsuccessfulPaymentHelper as default };